<template>
  <div>
    <template v-if="!denunciaId">
      <div class="row">
        <div class="col-3">
          <span>Número de expediente (Denuncia):</span><i class="fas fa-check-circle green" v-if="acuerdo.denunciaId"></i>
        </div>
      </div>
      <div class="row new-row">
        <div class="col-3">
          <input type="text" class="form-control" v-model="numeroDeExpedienteDenuncia" v-bind:disabled="acuerdo.denunciaId"/>
        </div>
        <div class="col-3">
          <input type="button" class="form-control" value="Validar No. Exp" @click="validarNumeroDeExpedienteDenuncia"/>
        </div>
        <div class="col-3">
          <input type="button" class="form-control" value="Cambiar No. Exp" @click="acuerdo.denunciaId = null" v-show="acuerdo.denunciaId"/>
        </div>
      </div>
    </template>
    <div class="row new-row">
      <div class="col-3">
        <span>Fecha de Dictado:</span>
      </div>
      <div class="col-3">
        <span>Fecha de Publicación:</span>
      </div>
      <!-- <div class="col-3">
        <span>Documento Anexo:</span>
      </div> -->
      <div class="col-6">
        <span>Extracto:</span>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <input
          type="date"
          class="form-control"
          name="fechaDeDictado"
          v-model="acuerdo.fechaDeDictado"
        />
      </div>
      <div class="col-3">
        <input
          type="date"
          class="form-control"
          name="fechaDePublicacion"
          v-model="acuerdo.fechaDePublicacion"
        />
      </div>
      <!-- <div class="col-3">
        <input type="file" class="form-control" name="rutaDeArchivo" />
      </div> -->
      <div class="col-6">
        <textarea
          class="form-control bigtextarea"
          name="extracto"
          v-model="acuerdo.extracto"
        ></textarea>
      </div>
    </div>
    <div class="row new-row">
      <div class="col-9"></div>
      <div class="col-3">
        <input
          type="button"
          value="Añadir Acuerdo"
          class="form-control"
          @click="registrarAcuerdo"
          v-bind:disabled="datosFinalesNoValidos"
        />
      </div>
    </div>
    <div class="row new-row">
      <TablaDeAcuerdos v-if="denunciaId"
        :prop_listaDeAcuerdos="listaDeAcuerdos"
        :key="listaDeAcuerdosKey"
      ></TablaDeAcuerdos>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import TablaDeAcuerdos from "@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/TablaDeAcuerdos.vue";
import { Acuerdo } from "@/components/SIFA/Comun/Modelos/Acuerdo.js";
import { Denuncia } from "@/components/SIFA/Comun/Modelos/Denuncia.js";
export default {
  data() {
    return {
      denunciaId: null,
      acuerdo: new Acuerdo(),
      listaDeAcuerdos: [],
      listaDeAcuerdosKey: 0,
      numeroDeExpedienteDenuncia: ""
    };
  },
  props: {
    prop_denunciaId: Number,
    prop_acuerdos: Array[Acuerdo],
  },
  components: {
    TablaDeAcuerdos,
  },
  methods: {
    registrarAcuerdo: function () {
      //Retorna una lista de citas 'Aceptadas'
      var peticion = {
        acuerdo: this.acuerdo,
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.RegistrarAcuerdo,
          peticion /*, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)*/
        )
        .then((response) => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            comun.mensajeDeAlerta(
              `${response.data.Satisfactorio}.`,
              null,
              null
            );
            const nuevaAcuerdo = new Acuerdo(
                response.data.acuerdoId,
                response.data.consecutivo,
                this.acuerdo.fechaDeDictado,
                this.acuerdo.extracto
              );
              nuevaAcuerdo.denuncia = this.acuerdo.denuncia;
            this.listaDeAcuerdos.push(nuevaAcuerdo);
            this.listaDeAcuerdosKey = response.data.acuerdoId;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    validarNumeroDeExpedienteDenuncia: function () {
      //Retorna una lista de citas 'Aceptadas'
      var peticion = {
        consecutivo: this.numeroDeExpedienteDenuncia,
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.ValidarNumeroDeExpedienteDenuncia,
          peticion /*, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)*/
        )
        .then((response) => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            this.acuerdo.denunciaId = response.data.denunciaId;
            if(this.acuerdo.denunciaId){
              this.acuerdo.denuncia = new Denuncia();
              this.acuerdo.denuncia.denunciante = response.data.denunciante;
              this.acuerdo.denuncia.consecutivo = this.numeroDeExpedienteDenuncia;
            }
            
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    generarTablaDeAcuerdosPDF: function () {
      //Retorna una lista de citas 'Aceptadas'
      var peticion = {
        acuerdos: this.listaDeAcuerdos,
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.GenerarTablaDeAcuerdosPDF,
          peticion /*, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)*/
        )
        .then((response) => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            console.log(response.data);
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
  },
  mounted: function mounted() {
    if (this.prop_denunciaId) this.denunciaId = this.prop_denunciaId;
    if (this.prop_acuerdos) {
      this.listaDeAcuerdos = this.prop_acuerdos;
      if (this.listaDeAcuerdos.length > 0) {
        this.listaDeAcuerdosKey =
          this.listaDeAcuerdos[
            this.listaDeAcuerdos.length - 1
          ].acuerdoId;
      }
    }
    const date = new Date();
    this.acuerdo.fechaDeDictado = date.toISOString().split("T")[0];
    date.setDate(new Date().getDate()+1)
    this.acuerdo.fechaDePublicacion = date.toISOString().split("T")[0];
    this.acuerdo.denunciaId = this.denunciaId;
  },
  computed: {
    datosFinalesNoValidos() {
      return !(this.acuerdo.denunciaId && this.acuerdo.fechaDeDictado && this.acuerdo.fechaDePublicacion && this.acuerdo.extracto) ;
    },
  },
};
</script>

<style scoped>
span {
  font-weight: bold;
}

b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}

.bigtextarea {
  height: 100px;
}
.green{
  color: greenyellow;
}
</style>



// WEBPACK FOOTER //
// src/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/Acuerdos.vue